<script>
import axios from '@/utils/axios';

const DEFAULT_FORM = () => ({
  employee_id: '',
  date: '',
  punch_in: '',
  punch_out: '',
  status: '',
  remarks: '',
});

export default {
  inject: ['setLoading'],
  emits: ['updated'],
  data() {
    return {
      form: DEFAULT_FORM(),
      errors: {},
      employees: [],
      statusOptions: [
        { v: 'present', l: 'Present' },
        { v: 'absent', l: 'Absent' },
        { v: 'half_day', l: 'Half Day' },
        { v: 'late', l: 'Late' },
        { v: 'on_leave', l: 'On Leave' },
        { v: 'holiday', l: 'Holiday' },
      ],
    };
  },
  mounted() {
    this.fetchEmployees();
  },
  methods: {
    async fetchEmployees() {
      try {
        const res = await axios.get('/hrms/employees/dropdown');
        this.employees = res.data.data || [];
      } catch (error) {
        console.log(error.message);
      }
    },
    employeeLabel(e) {
      return e.full_name || `${e.first_name || ''} ${e.last_name || ''}`.trim();
    },

    open() {
      this.resetForm();
    },

    // "10:00" (input type=time) -> "10:00:00" (backend H:i:s)
    toApiTime(t) {
      if (!t) return null;
      return t.length === 5 ? `${t}:00` : t;
    },

    async save() {
      this.errors = {};
      this.setLoading(true);
      try {
        const payload = {
          employee_id: this.form.employee_id || null,
          date: this.form.date || null,
          punch_in: this.toApiTime(this.form.punch_in),
          punch_out: this.toApiTime(this.form.punch_out),
          status: this.form.status || null,
          remarks: this.form.remarks || null,
        };
        const res = await axios.post('/hrms/attendances/manual-entry', payload);
        this.$swalToast(res.data.message || 'Attendance added.');
        this.$emit('updated');
        this.$closeModal('hrm_attendance_manual_modal');
        this.resetForm();
      } catch (error) {
        if (error.type === 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    resetForm() {
      this.form = DEFAULT_FORM();
      this.errors = {};
    },

    err(f) {
      return this.errors[f] ? this.errors[f][0] : '';
    },
  },
};
</script>

<template>
  <div class="modal fade" id="hrm_attendance_manual_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Manual Attendance Entry</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="save">
          <div class="modal-body pb-0">

            <div class="mb-3">
              <label class="form-label">Employee <span class="text-danger">*</span></label>
              <select class="form-select" v-model="form.employee_id">
                <option value="">Select employee</option>
                <option v-for="e in employees" :key="e.id" :value="e.id">{{ employeeLabel(e) }}</option>
              </select>
              <div v-if="err('employee_id')" class="text-danger small mt-1">{{ err('employee_id') }}</div>
            </div>

            <div class="mb-3">
              <label class="form-label">Date <span class="text-danger">*</span></label>
              <input type="date" class="form-control" v-model="form.date" />
              <div v-if="err('date')" class="text-danger small mt-1">{{ err('date') }}</div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Punch In <span class="text-danger">*</span></label>
                <input type="time" step="1" class="form-control" v-model="form.punch_in" />
                <div v-if="err('punch_in')" class="text-danger small mt-1">{{ err('punch_in') }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Punch Out <span class="text-danger">*</span></label>
                <input type="time" step="1" class="form-control" v-model="form.punch_out" />
                <div v-if="err('punch_out')" class="text-danger small mt-1">{{ err('punch_out') }}</div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">Status</label>
              <select class="form-select" v-model="form.status">
                <option value="">Auto (let system decide)</option>
                <option v-for="s in statusOptions" :key="s.v" :value="s.v">{{ s.l }}</option>
              </select>
              <div v-if="err('status')" class="text-danger small mt-1">{{ err('status') }}</div>
            </div>

            <div class="mb-3">
              <label class="form-label">Remarks</label>
              <textarea class="form-control" rows="2" v-model="form.remarks" placeholder="Optional note"></textarea>
              <div v-if="err('remarks')" class="text-danger small mt-1">{{ err('remarks') }}</div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary">Save Entry</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>